import { useEffect } from 'react';
import { DownloadIcon } from '@rsos/assets/icons';
import Dropdown from '@rsos/components/capstone/base/Dropdown';
import {
  DropdownDialog,
  DropdownBody,
  DropdownList,
} from '@rsos/components/capstone/base/Dropdown/DropdownComponents';
import { DropdownDownloadItem } from '../DropdownDownload/DropdownDownloadItem';
import {
  CustomToolTip,
  TooltipChild,
  DownloadBtn,
  TOOLTIP_HEIGHT,
  TOOLTIP_CHILD_OFFSET,
} from '../styles/CommunicationHistoryTable.styles';
import { IconWrapper } from '../styles/CommunicationHistoryTableContainer.styles';

const DOWNLOAD_TOOLTIP_WIDTH = '95px';
const DROPDOWN_WIDTH = '135px';
const DROPDOWN_DIALOG_OFFSET = TOOLTIP_HEIGHT + TOOLTIP_CHILD_OFFSET;
const DOWNLOAD_ALL = 'Download All';
const DOWNLOAD_SELECTED = 'Download Selected';

export const DropdownButton = ({
  hasAnyCheckedBox,
  onDownloadClicked,
  setIsDownloadDropdownVisible,
  showDropdown,
}) => {
  const DownloadBtnComponent = ({ onClick, selected }) => {
    useEffect(() => {
      setIsDownloadDropdownVisible(selected);
    }, [selected]);
    return (
      <CustomToolTip>
        <TooltipChild width={DOWNLOAD_TOOLTIP_WIDTH}>
          Download as CSV
        </TooltipChild>
        <DownloadBtn
          disabled={!hasAnyCheckedBox}
          onClick={() => showDropdown(onClick)}
        >
          <IconWrapper isDisabled={!hasAnyCheckedBox}>
            <DownloadIcon
              width={12}
              height={12}
              color="primaryText"
              viewboxWidth={8}
              viewboxHeight={12}
            />
          </IconWrapper>
        </DownloadBtn>
      </CustomToolTip>
    );
  };
  return (
    <Dropdown
      triggerElement={DownloadBtnComponent}
      triggerOnClose
      position="inherit"
    >
      {onDropdownClose => (
        <DropdownDialog
          top={DROPDOWN_DIALOG_OFFSET}
          right={0}
          width={DROPDOWN_WIDTH}
        >
          <DropdownBody>
            <DropdownList borderless padding="8px 0">
              <DropdownDownloadItem
                onDropdownClose={onDropdownClose}
                onDownloadClicked={onDownloadClicked}
                text={DOWNLOAD_ALL}
                margin="8px 0 0 0"
                downloadAll
              />
              <DropdownDownloadItem
                onDropdownClose={onDropdownClose}
                onDownloadClicked={onDownloadClicked}
                text={DOWNLOAD_SELECTED}
                margin="0 0 8px 0"
              />
            </DropdownList>
          </DropdownBody>
        </DropdownDialog>
      )}
    </Dropdown>
  );
};
